import { makeStyles, Paper } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import TabPanel from "components/common/TabPanel";
import withLayout from "components/HoC/withLayout";
import StepContainer, {
  SectionM24Step,
} from "components/request-document/StepContainer";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPersonalDetail,
  selectPersonalDetail,
} from "redux/modules/personalSlice";
import {
  clearSmartFormStep,
  initRouter,
  selectHomeTab,
  selectIsExtension,
  selectIsM24,
  setHomeTab,
  setIsExtension,
  setM24,
  setSmartFormStep,
} from "redux/modules/uiSlice";
import { currentDocumentSlice } from "redux/modules/visaForm";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 10px",
  },
  label: {
    alignItems: "flex-start",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
}));

function HomePage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const homeTab = useSelector(selectHomeTab);
  const personalDetail = useSelector(selectPersonalDetail);
  const isExtension = useSelector(selectIsExtension);
  const isM24 = useSelector(selectIsM24);

  const personalId = get(personalDetail, "personalID", "");

  useEffect(() => {
    // if (homeTab === HOME_TAB.COMPANY) {
    //   dispatch(setM24(true));
    //   dispatch(
    //     initRouter([
    //       SMART_T_STEP.INSTITUTION_COMPANY,
    //       SMART_T_STEP.COMPANY_UPLOAD_DOCUMENT,
    //     ])
    //   );
    //   dispatch(setSmartFormStep(SMART_T_STEP.INSTITUTION_COMPANY));
    // }
    if (homeTab === HOME_TAB.EMPLOYEE_LIST) {
      dispatch(setM24(true));
      dispatch(
        initRouter([
          SMART_T_STEP.EMPLOYEE_LIST,
          SMART_T_STEP.UPLOAD_PASSPORT,
          SMART_T_STEP.PART_A_1,
          SMART_T_STEP.PART_A_2,
          SMART_T_STEP.UPLOAD_DOCUMENT,
        ])
      );
      dispatch(setSmartFormStep(SMART_T_STEP.EMPLOYEE_LIST));
    }

    if (homeTab === HOME_TAB.HISTORY) {
      dispatch(setM24(true));
    }
  }, [homeTab]);

  const handleChange = (event, newValue) => {
    dispatch(setHomeTab(newValue));
    dispatch(currentDocumentSlice.actions.clearAsyncState());
    dispatch(clearSmartFormStep());

    if (isExtension) {
      dispatch(setIsExtension(false));
    }

    if (isM24) {
      dispatch(setM24(false));
    }

    if (newValue === HOME_TAB.COMPANY) {
      dispatch(setM24(true));
      dispatch(
        initRouter([
          SMART_T_STEP.INSTITUTION_COMPANY,
          SMART_T_STEP.COMPANY_UPLOAD_DOCUMENT,
        ])
      );
      dispatch(setSmartFormStep(SMART_T_STEP.INSTITUTION_COMPANY));
    } else if (newValue === HOME_TAB.EMPLOYEE_LIST) {
      dispatch(setM24(true));
      dispatch(
        initRouter([
          SMART_T_STEP.EMPLOYEE_LIST,
          SMART_T_STEP.UPLOAD_PASSPORT,
          SMART_T_STEP.PART_A_1,
          SMART_T_STEP.PART_A_2,
          SMART_T_STEP.UPLOAD_DOCUMENT,
        ])
      );
      dispatch(setSmartFormStep(SMART_T_STEP.EMPLOYEE_LIST));
    }

    if (personalId) {
      dispatch(getPersonalDetail({ personalId })); // TODO wait for refactor
    }
  };

  return (
    <>
      <Tabs
        value={homeTab}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        aria-label="disabled tabs example"
      >
        <Tab label="Employee list" />
        <Tab label="Company" />
        <Tab label="History" />
      </Tabs>
      <TabPanel value={homeTab} index={HOME_TAB.EMPLOYEE_LIST}>
        <Paper className={classes.paper}>
          <SectionM24Step />
        </Paper>
      </TabPanel>
      <TabPanel value={homeTab} index={HOME_TAB.COMPANY}>
        <Paper className={classes.paper}>
          <SectionM24Step />
        </Paper>
      </TabPanel>
      <TabPanel value={homeTab} index={HOME_TAB.HISTORY}>
        <Paper className={classes.paper}>
          <StepContainer />
        </Paper>
      </TabPanel>
    </>
  );
}

export default withLayout(HomePage);
